import $ from 'jquery';
import CheckoutController from './CheckoutController';

/**
 * Express Checkout Controller
 *
 * Handles express checkout-specific payment flow orchestration.
 * Express checkout is typically rendered on checkout pages as a quick payment option.
 */
class ExpressCheckoutController extends CheckoutController {

    initialize() {
        this.actions.addAction('updated_checkout', this.updatedCheckout.bind(this));
        this.loadPayPalScript().then(async () => {
            this.createPaymentElement();
        });
    }

    updatedCheckout(data) {
        if (this.paypal) {
            this.createPaymentElement();
        }
        this.updateGatewaySettings(data);
    }

    needsShipping() {
        return this.cart.needsShipping();
    }

    validate() {
        return true;
    }

    submit(checkoutData = null) {
        super.submit(checkoutData);
        const container = super.getElementContainer();
        if (container) {
            $(container).hide();
        }
    }

    /**
     * Get the element container for express checkout buttons
     * @returns {HTMLElement|null} The container element
     */
    getElementContainer() {
        if (this.settings?.expressElement) {
            const container = document.querySelector(this.settings.expressElement);
            if (container) {
                return container;
            }
        }
        return document.getElementById(`wc-${this.id}-express-button`);
    }

    /**
     * Called when payment element is ready
     * Overrides base to trigger express checkout specific initialization
     */
    onPaymentElementReady() {
        this.actions.doAction('payment_element_ready', this);
        // Show the container after buttons are created
        const container = this.getElementContainer();
        if (container) {
            $(container).show();
            this.addExpressClasses($(container));
        }
        $('.wc-ppcp-express-checkout').show();
    }

    /**
     * Add express-specific CSS classes based on button count
     * @param {jQuery} $container - The container element
     */
    addExpressClasses($container) {
        if ($container.length && this.gateway.buttons) {
            const count = Object.keys(this.gateway.buttons).length;
            $container.addClass(`button-count_${count}`);
        }
    }

    /**
     * Called when express checkout button is clicked
     * Automatically checks terms and selects payment method
     */
    onClick() {
        // Auto-check terms and conditions
        $('[name="terms"]').prop('checked', true).trigger('change');

        // Select this payment method
        $(`[name="payment_method"][value="${this.id}"]`).prop("checked", true).trigger('click');

        // Select "new" payment token (not saved payment method)
        $(`[name="wc-${this.id}-payment-token"][value="new"]`).trigger('click');
    }

    paymentMethodSelected() {

    }

    hidePaymentElement() {

    }

}

export {ExpressCheckoutController};
export default ExpressCheckoutController;